module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-5-56cc531e55e237ce71d190f6cfec7faf.jpg";